import {StorageHelper} from "../common/storageHelper";
import axios from "axios";

export default {
    async created () {
        let countryCodeStored = StorageHelper.getDefaultCountryCode();
        let timezoneCodeStored = StorageHelper.getDefaultTimeZone();
        let currencyStored = StorageHelper.getDefaultCurrency();

        if (!countryCodeStored || !timezoneCodeStored || !currencyStored) {
            await axios.get ('https://ipapi.co/json/')
                .then(response => {
                    if (!countryCodeStored) {
                        StorageHelper.setDefaultCountryCode(response.data.country_code)
                    }

                    if (!timezoneCodeStored) {
                        StorageHelper.setDefaultTimeZone(response.data.timezone)
                    }

                    if (!currencyStored) {
                        StorageHelper.setDefaultCurrency(response.data.currency)
                    }
                })
                .catch(error => {
                    console.log(error);
                })
            location.reload();
        }
    }
}
